module.exports = __webpack_public_path__ + "static/media/purple-svcc.fcad429e.png";